import { QueryClient } from "@tanstack/react-query";
import { shouldRedactRequestError } from "#/_packages/umbrella/lib/orval/request-error.ts";
import type { UmbracoBlockPreviewBlock } from "#/app/routes/_umbraco/_preview/umbraco/block-preview.tsx";

export function getContext() {
	const queryClient = new QueryClient({
		defaultOptions: { dehydrate: { shouldRedactErrors: shouldRedactRequestError } },
	});

	return {
		queryClient,
	};
}

type PreviewContext = {
	queryClient: QueryClient;
	block?: UmbracoBlockPreviewBlock;
};

export function getPreviewContext(): PreviewContext {
	const queryClient = new QueryClient({
		defaultOptions: { dehydrate: { shouldRedactErrors: shouldRedactRequestError } },
	});

	return {
		queryClient,
	};
}

export default function TanstackQueryProvider() {}
